import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from "@angular/material";
import { ToastrService } from "ngx-toastr";
import { first } from "rxjs/operators";
import { EnforcementVehicleService } from "src/app/services/enforcement-vehicle.service";
import { TokenStorage } from "src/app/util/token.storage";
import { WebConstants } from "src/app/util/web.constants";
import { VehicleAddDialogComponent } from "./vehicle-add-dialog/vehicle-add-dialog.component";
import { VehicleUpdateDialogComponent } from "./vehicle-update-dialog/vehicle-update-dialog.component";

@Component({
  selector: "app-enforcement-vehicle",
  templateUrl: "./enforcement-vehicle.component.html",
  styleUrls: ["./enforcement-vehicle.component.scss"],
})
export class EnforcementVehicleComponent implements OnInit {
  public displayedColumns: string[] = [
    "name",
    "make",
    "model",
    "lpn",
    "peoId",
    "cameraGroupId",
    "createdDate",
    "actions",
  ];

  public title: string = WebConstants.MENU_NAMES.ENFORCEMENT_VEHICLE;
  public enforcementvehicleList: any[] = [];
  public dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  tempId: any;

  constructor(
    public enforcementVehicleService: EnforcementVehicleService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.getAllEnforcementVehicle();
  }

  getAllEnforcementVehicle(): void {
    this.enforcementVehicleService
      .getAll()
      .pipe(first())
      .subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.enforcementvehicleList = response.data;
          this.dataSource = new MatTableDataSource(this.enforcementvehicleList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  addVehicleDialog(): void {
    const dialogRef = this.dialog.open(VehicleAddDialogComponent, {
      data: null,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true){
        this.getAllEnforcementVehicle();
      }      
    });
  }

  getTempId(obj: any){
    this.tempId = obj;
  }

  deleteVehicle(vehicle: any): void {
    this.enforcementVehicleService.deleteVehicle(vehicle.lpn)
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.toastrService.success(response.value, "Vehicle Deleted Successfully!");
        this.getAllEnforcementVehicle();        
      } else {
        this.toastrService.error(response.value, "Failed To Delete Data!")
      }
    });
  }

  updateVehicleDialog(data: any): void {
    const dialogRef = this.dialog.open(VehicleUpdateDialogComponent, {
      data: data,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true){
        this.getAllEnforcementVehicle();
      }
    });
  }
  
}
